import { render } from "./EstatusSegmento.vue?vue&type=template&id=00738944&scoped=true"
import script from "./EstatusSegmento.vue?vue&type=script&lang=js"
export * from "./EstatusSegmento.vue?vue&type=script&lang=js"

import "./EstatusSegmento.vue?vue&type=style&index=0&id=00738944&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Josue\\Documents\\IMSS\\CDI\\SITE\\frontrdsyuc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00738944"]])

export default __exports__